import {type EquipmentPerformance} from '@hconnect/common/types'

const hasKpiAssignments = (equipmentPerformance: EquipmentPerformance): boolean => {
  const {kpiPerformance} = equipmentPerformance
  return !!kpiPerformance?.kpiAssignments?.length
}

export const checkIfKpiPerformanceIsAvailable = (
  equipmentPerformances?: EquipmentPerformance[]
): boolean => equipmentPerformances?.some(hasKpiAssignments) ?? false

export const filterEquipmentsWithKpiAssignments = (
  equipmentPerformances?: EquipmentPerformance[]
) => equipmentPerformances?.filter(hasKpiAssignments)
